import React from "react";
import { Download } from "lucide-react";
import { Button } from "../../components/ui/button";

// Constants for app download links
const APPLE_APP_STORE_URL = "https://apps.apple.com/ca/app/pagent/id6670614673";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.pagent";

export default function AboutSection() {
  return (
    <section id="about" className="py-24 relative">
      {/* Decorative flower */}
      <div className="absolute top-12 right-8 md:right-24 lg:right-48 w-24 h-24 md:w-32 md:h-32 opacity-80 pointer-events-none">
        <img
          src="/images/img_vector_yellow_a400.svg"
          alt=""
          className="w-full h-full object-contain"
        />
      </div>

      <div className="container max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl">
              About Pagent
            </h2>
            <div className="space-y-4">
              <p className="text-lg text-muted-foreground">
                Pagent is a social gaming app that connects you with new people
                and lets you share your skill and creativity. Play against
                similarly skilled users in challenges to earn badges and rise to
                the top of the leaderboard.
              </p>
              <p className="text-lg text-muted-foreground">
                Compete in live challenges to showcase your talent in your
                chosen category and connect with others who share your
                interests.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
              <a
                href={APPLE_APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-transform hover:scale-105"
              >
                <div
                  className="rounded-lg overflow-hidden"
                  style={{ maxWidth: "180px" }}
                >
                  <img
                    src="/images/AppStoreFig.png"
                    alt="Download on App Store"
                    className="h-auto w-full object-contain"
                  />
                </div>
              </a>
              <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-transform hover:scale-105"
              >
                <div
                  className="rounded-lg overflow-hidden"
                  style={{ maxWidth: "180px" }}
                >
                  <img
                    src="/images/GoogleStoreFig.png"
                    alt="Get it on Google Play"
                    className="h-auto w-full object-contain"
                  />
                </div>
              </a>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-lg relative">
            <img
              src="/images/the_first_kind_v2.png"
              alt="Pagent App"
              className="w-full h-auto object-cover"
            />

            {/* Small flower decoration on the image */}
            <div className="absolute -bottom-4 -left-4 w-16 h-16 opacity-90 pointer-events-none">
              <img
                src="/images/img_vector_yellow_a400.svg"
                alt=""
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
